import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import ReactDatePicker from"../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector(
    (state) => state.multiLocationOverview.selectedRequestDates
  );
  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.multiLocationOverview.currentUser
  );

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate: startDate, endDate: endDate }))
      }
    />
  );
};

export default DatePicker;
